import FinishScreen from './index';

const routes = [
  {
    path: '/onboarding-finish',
    component: FinishScreen,
  },
];

export default routes;
